import React, { useState, useEffect } from 'react';
import { Table, Button, message, Popconfirm } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { getSubcontractorEmployees, deleteSubcontractorEmployee } from '../api';
import { EyeOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';

const SubcontractorEmployees = () => {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { subcontractorId } = useParams();

  const fetchEmployees = async () => {
    if (!subcontractorId) return;
    setLoading(true);
    const res = await getSubcontractorEmployees(subcontractorId);
    setLoading(false);
    if (res.success) {
      setEmployees(res.data);
    } else {
      message.error(res.message || 'Failed to fetch employees');
    }
  };

  useEffect(() => {
    fetchEmployees();
  }, [subcontractorId]);

  const handleDelete = async (id) => {
    const res = await deleteSubcontractorEmployee(id);
    if (res.success) {
      message.success('Employee deleted');
      fetchEmployees();
    } else {
      message.error(res.message || 'Delete failed');
    }
  };

  const columns = [
    {
      title: 'S.No',
      key: 'sno',
      width: 60,
      render: (_, __, index) => index + 1
    },
    { title: 'Name', dataIndex: 'name', key: 'name' },
    { title: 'Email', dataIndex: 'email', key: 'email' },
    { title: 'Phone', dataIndex: 'phone', key: 'phone' },
    { title: 'Position', dataIndex: 'position', key: 'position' },
    { title: 'Skill', dataIndex: ['skill', 'name'], key: 'skill', render: skill => skill || 'N/A' },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <>
          <Button size="small" icon={<EyeOutlined />} style={{ marginRight: 8 }} onClick={() => navigate(`/subcontractors/${subcontractorId}/employees/${record.id}/view`)} />
          <Button size="small" icon={<EditOutlined />} style={{ marginRight: 8 }} onClick={() => navigate(`/subcontractors/${subcontractorId}/employees/${record.id}/edit`)} />
          <Popconfirm title="Are you sure to delete?" onConfirm={() => handleDelete(record.id)}>
            <Button size="small" icon={<DeleteOutlined />} danger />
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h3>Employees</h3>
        <Button type="primary" onClick={() => navigate(`/subcontractors/${subcontractorId}/employees/add`)}>
          Add Employee
        </Button>
      </div>
      <Table
        dataSource={employees}
        columns={columns}
        loading={loading}
        rowKey="id"
        size="small"
      />
    </div>
  );
};

export default SubcontractorEmployees; 